export const LINKS = {
  recomendedPage: "https://laurenwallett.com/contentwallett/",
  waitlistPage: "https://creatrixsaas.com/waitlist",
};
